/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExamenEntreeFichierGridDto
 */
export interface ExamenEntreeFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFichierGridDto
     */
    idexamenEntreeFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFichierGridDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof ExamenEntreeFichierGridDto
     */
    typeAcquisFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExamenEntreeFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExamenEntreeFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ExamenEntreeFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the ExamenEntreeFichierGridDto interface.
 */
export function instanceOfExamenEntreeFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExamenEntreeFichierGridDtoFromJSON(json: any): ExamenEntreeFichierGridDto {
    return ExamenEntreeFichierGridDtoFromJSONTyped(json, false);
}

export function ExamenEntreeFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamenEntreeFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idexamenEntreeFichier': !exists(json, 'idexamenEntreeFichier') ? undefined : json['idexamenEntreeFichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'typeAcquisFichier': !exists(json, 'typeAcquisFichier') ? undefined : json['typeAcquisFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function ExamenEntreeFichierGridDtoToJSON(value?: ExamenEntreeFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idexamenEntreeFichier': value.idexamenEntreeFichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'typeAcquisFichier': value.typeAcquisFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

